import { makeStyles } from '@mui/styles';
import qs from 'query-string';
import React from 'react';
import { useLocation } from 'react-router-dom';

import Link from './Link';
import { FILE_DOWNLOAD } from '../constants/Urls';
import { fetchAttachmentFromServer } from '../form-designer/utils/controls/ssHyperLink.utils';
import { appendChildWindow } from '../utils/childrenWindowsUtils';

const useStyles = makeStyles({
  linkContainer: {
    color: '#06C',
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

const NavigateLink = ({ to, target, onClick = () => {}, children, row = {}, ...props }) => {
  const classes = useStyles();
  const location = useLocation();

  const handleFileDownloadLinkClick = (e) => {
    e.preventDefault();
    const query = qs.parse(to.search);
    const { filename, isDocumentContent } = query;
    const { enableBrowserHandling } = qs.parse(location.search) || {};

    const params = {
      ...query,
      enableBrowserHandling,
      isForDownload: isDocumentContent,
    };

    const fileNameText = filename || row.ACO_FILE_NAME;
    const downloadOptions = { ...params };

    fetchAttachmentFromServer(fileNameText, downloadOptions);
  };

  const handleClick = (e) => {
    typeof onClick === 'function' && onClick();

    const { target, href } = e.currentTarget;
    const { pathname } = to;

    const isFileDownLoadLink = pathname && pathname.includes(FILE_DOWNLOAD);

    if (isFileDownLoadLink) {
      handleFileDownloadLinkClick(e);
      return;
    }

    if (target === '_blank') {
      e.preventDefault();
      appendChildWindow(window.open(href, target));
    }
  };

  return (
    <Link
      to={to}
      target={target}
      onClick={handleClick}
      className={classes.linkContainer}
      {...props}
      aria-label="File Download"
      isSavedSearchLink
    >
      {children}
    </Link>
  );
};

export default NavigateLink;
